import React from "react";
import { Paperclip, Pencil, Check, Trash2, FileText } from "lucide-react";

const PREVIEW_PAGE_HINTS = {
  research: "Available at Research page",
  debate: "Available at Debate page",
};

export function PreviewUnavailableHint({ hint, children, className = "" }) {
  return (
    <span className={`nl-preview-unavail-wrap${className ? ` ${className}` : ""}`}>
      {children}
      <span className="nl-preview-unavail-hint" role="tooltip">
        {hint}
      </span>
    </span>
  );
}

export function PreviewAttachButton({ page = "research" }) {
  const hint = PREVIEW_PAGE_HINTS[page] || PREVIEW_PAGE_HINTS.research;
  return (
    <PreviewUnavailableHint hint={hint}>
      <button
        type="button"
        className="nl-research-attach nl-preview-unavail-btn"
        disabled
        aria-label={`Attach file — ${hint}`}
      >
        <Paperclip size={14} aria-hidden="true" />
        Attach file
      </button>
    </PreviewUnavailableHint>
  );
}

export function PreviewTopbar({ label, badge, extra }) {
  return (
    <div className="topbar">
      <span className="dot dot-r" />
      <span className="dot dot-y" />
      <span className="dot dot-g" />
      <div className="topbar-right">
        {extra}
        <span className="topbar-label">{label}</span>
        <span className="topbar-badge">{badge}</span>
      </div>
    </div>
  );
}

export function PreviewQueryRow({ label, text }) {
  return (
    <div className="query-row">
      <div className="query-lbl">{label}</div>
      <div className="query-text">{text}</div>
      <div className="attach-cue">
        <Paperclip size={14} aria-hidden="true" />
        Attach file
      </div>
    </div>
  );
}

export function PreviewEditExportButton({
  onClick,
  disabled = false,
  className = "nl-response-btn",
}) {
  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      disabled={disabled}
    >
      Edit / Export
    </button>
  );
}

export function PreviewPanelActions({ page = "research", onEditExport }) {
  const hint = PREVIEW_PAGE_HINTS[page] || PREVIEW_PAGE_HINTS.research;
  return (
    <div className="panel-actions panel-actions-preview">
      <button
        type="button"
        className="btn-action-ghost btn-action-edit"
        onClick={onEditExport}
      >
        <Pencil size={13} aria-hidden="true" />
        Edit / Export
      </button>
      <PreviewUnavailableHint hint={hint} className="nl-preview-exec-wrap">
        <span
          className="btn-action-blue btn-action-exec nl-preview-unavail-chip"
          role="presentation"
          aria-label={`Create Executive Summary — ${hint}`}
        >
          <FileText size={13} aria-hidden="true" />
          Create Executive Summary
        </span>
      </PreviewUnavailableHint>
    </div>
  );
}

export function AiCardFooter() {
  return (
    <div className="ai-card-footer">
      <span className="card-edit-link" role="presentation">
        <Pencil size={11} aria-hidden="true" />
        Edit / Export
      </span>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
        <span className="card-complete">
          <Check size={11} aria-hidden="true" />
          Complete
        </span>
        <span className="card-trash" title="Delete" role="presentation">
          <Trash2 size={13} aria-hidden="true" />
        </span>
      </span>
    </div>
  );
}

export function SectionCta({ onClick, children, sub }) {
  return (
    <div className="section-cta">
      <button type="button" className="nl-section-cta-btn nl-btn-unstyled" onClick={onClick}>
        <span className="nl-cta-play-circle" aria-hidden="true">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="nl-cta-play-svg"
          >
            <path d="M3 2L12 7L3 12V2Z" fill="currentColor" />
          </svg>
        </span>
        <span className="nl-cta-label">{children}</span>
        <span className="nl-cta-arrow" aria-hidden="true">→</span>
      </button>
      {sub && <p>{sub}</p>}
    </div>
  );
}


